import { gql } from '@apollo/client/core';

export const PACING_METRICS = gql`
  fragment pacingMetrics on PacingMetrics {
    pacing
    totalImpressions
  }
`;
